import type { CartBase } from '@maestro/data-layer'

import { createLogger } from '@maestro/core/logger'
import { theme } from '@maestro/local/theme'

const log = createLogger('maestro:commerce-blocks:cart-store')

export function isCartIdActive(cart: CartBase): boolean {
  if (!cart.cartId) {
    return false
  }
  return cart.ttl > Date.now()
}

export function createTTL(days?: number): number {
  const daysInMilliseconds =
    (days || theme().cart.expires) * theme().cart.oneDayInMilliseconds
  return Date.now() + daysInMilliseconds
}

export function getCartIdFromStorage(): CartBase {
  if (typeof window === 'undefined') {
    return {
      cartId: '',
      cartVersion: 0,
      customerId: undefined,
      ttl: 0,
      totalQuantity: 0,
    }
  }
  try {
    const data = JSON.parse(localStorage.getItem('cartId') || '{}')
    return {
      cartId: data.id || '',
      cartVersion: Number(data.version) || 0,
      customerId: data.customerId || undefined,
      ttl: Number(data.ttl) || 0,
      totalQuantity: Number(data.totalQuantity) || 0,
    }
  } catch (error) {
    log.error('Error parsing cartId from localStorage:', error)
    return {
      cartId: '',
      cartVersion: 0,
      customerId: undefined,
      ttl: 0,
      totalQuantity: 0,
    }
  }
}

export function saveCartIdToStorage({
  cartId,
  cartVersion,
  customerId,
  ttl,
  totalQuantity,
}: CartBase): void {
  if (typeof window === 'undefined' || !cartId) {
    return
  }

  const cartData = {
    customerId: customerId || undefined,
    id: cartId,
    version: Number(cartVersion) || 0,
    ttl: ttl || createTTL(),
    totalQuantity: Number(totalQuantity) || 0,
  }
  localStorage.setItem('cartId', JSON.stringify(cartData))
}

export function deleteCartIdFromStorage() {
  if (typeof window === 'undefined') {
    return
  }

  localStorage.removeItem('cartId')
}

export function isGuestCart(cartData: CartBase): boolean {
  return !cartData.customerId
}

export function isUserCart(
  cartData: CartBase,
  customerId: string | undefined
): boolean {
  return customerId !== undefined && cartData.customerId === customerId
}
